// extracted by mini-css-extract-plugin
module.exports = {"reportHistoryPanel":"ReportHistoryPanel_reportHistoryPanel__35h9f"};